import {useEffect, useState} from 'react'
import {useTranslation} from 'react-i18next'
import {useAppDispatch} from '../../../redux/hooks'
import Loader from 'app/custom/loader/Loader'
import Chart from 'react-apexcharts'
import {StdFinancialStatus} from '../../../redux/Slice/studentSlice'
import {useAuth} from 'app/modules/auth'
const StdAccountPayment = () => {
  const {t} = useTranslation()
  const dispatch = useAppDispatch()
  const {currentUser} = useAuth()

  const [loaderSummary, setLoaderSummary] = useState(true)
  const [statistics, setStatistics] = useState<any>({})

  useEffect(() => {
    dispatch(StdFinancialStatus()).then((res: any) => {
      if (res.meta.requestStatus === 'fulfilled') {
        setStatistics(res.payload || {})
        setLoaderSummary(false)
      }
    })
  }, [])

  const paidTotal = Number(statistics?.total_paid ?? 0)
  const unpaidTotal = Number(statistics?.total_unpaid ?? 0)
  const latePayments = Number(statistics?.late_payments ?? 0)

  const donutSeries = paidTotal + unpaidTotal > 0 ? [paidTotal, unpaidTotal, latePayments] : [1, 1]

  const donutOptions: ApexCharts.ApexOptions = {
    chart: {type: 'donut'},

    labels: [t('LABEL.TOTAL_PAID'), t('LABEL.TOTAL_DUE'), t('LABEL.LATE_PAYMENT')],

    colors: ['#2DB36C', '#7239ea', '#f1416c'],
    legend: {show: false},
    dataLabels: {
      enabled: true,
      formatter: (val: number) => `${Math.round(val)}%`,
    },

    plotOptions: {
      pie: {
        donut: {
          size: '60%',
          labels: {
            show: false,
          },
        },
      },
    },
    tooltip: {
      y: {
        formatter: (value: number) => {
          return value.toLocaleString()
        },
      },
    },
  }

  if (loaderSummary) return <Loader />

  return (
    <div className='col-12 mt-3 p-none'>
      <div className='card shadow-sm border-0'>
        <div className='card-body'>
          <h4 className='fw-bold mb-4'>{t('DASHBOARD.AT_A_GLANCE')}</h4>

          <div className='d-flex align-items-center'>
            <Chart options={donutOptions} series={donutSeries} type='donut' width={250} />

            <div className='ms-4 w-100'>
              <div className='d-flex justify-content-between bg-light rounded px-3 py-2 mb-2'>
                <span className='fw-bold text-dark fs-4'>{t('LABEL.TOTAL_AMOUNT')}</span>
                <span className='text-dark fw-bold fs-4'>
                  {statistics?.currency ?? ''} {statistics?.total_invoices ?? 0}
                </span>
              </div>

              <div className='d-flex justify-content-between bg-light-success rounded px-3 py-2 mb-2'>
                <span className='fw-bold text-success fs-4'>{t('LABEL.TOTAL_PAID')}</span>
                <span className='fw-bold text-success fs-4'>
                  {statistics?.currency ?? ''} {paidTotal}
                </span>
              </div>
              <div className='d-flex justify-content-between bg-light-info rounded px-3 py-2 mb-2'>
                <span className='fw-bold text-info fs-4'>{t('LABEL.TOTAL_DUE')}</span>
                <span className='fw-bold text-info fs-4'>
                  {statistics?.currency ?? ''} {unpaidTotal}
                </span>
              </div>
              <div className='d-flex justify-content-between bg-light-danger rounded px-3 py-2 mb-2'>
                <span className='fw-bold text-danger fs-4'>{t('LABEL.LATE_PAYMENT')}</span>
                <span className='fw-bold text-danger fs-4'>
                  {statistics?.currency ?? ''} {latePayments}
                </span>
              </div>
              {statistics?.next_payment_date !== '' &&
                statistics?.next_payment_date !== null &&
                statistics?.next_payment_date !== 'null' && (
                  <div className='d-flex justify-content-between bg-light-warning rounded px-3 py-2 payment-alert'>
                    <span className='fw-bold text-dark fs-4'>
                      {t('LABEL.NEXT_PAYMENT_DATE')} ({statistics?.next_payment_date})
                    </span>
                    <span className='fw-bold text-dark fs-4'>
                      {statistics?.currency ?? ''} {statistics?.next_payment_amount ?? ''}
                    </span>
                  </div>
                )}
            </div>
          </div>
        </div>
        {currentUser?.campus_id === 17 && (
          <div className='card-footer'>
            <b className='text-danger'>Note extrêmement importante :</b>
            <br />
            <b>
              Tous les paiements doivent être effectués exclusivement par virement bancaire sur l’un
              des comptes ci-dessous.
              <br />
              Aucun paiement en espèces et aucun versement sur un autre compte ne sera considéré
              comme valable.
            </b>
            <br />
            Il est de la responsabilité du payeur de vérifier les coordonnées bancaires avant tout
            règlement.
            <br />
            <br />
            <b>Banque:BGFI</b>
            <br />
            IBAN : SN18 9010 0100 1210 6489 0195 <br />
            BIC : BGTSNDAAXXX <br />
            Titulaire : SWISS UMEF UNIVERSITY - Campus Dakar
            <br />
            <br />
            <b>Banque:CBAO </b>
            <br />
            SN01 2012 7003 6214 9058 0150 <br />
            BIC : CBAOSNDAXXX <br />
            Titulaire : SWISS UMEF UNIVERSITY - Campus Dakar
          </div>
        )}
      </div>
    </div>
  )
}

export default StdAccountPayment
